/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S62_TitleInputs */

const es_tyc_liability_s62_title = /** @type {(inputs: Tyc_Liability_S62_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6.2 Exclusiones`)
};

const en_tyc_liability_s62_title = /** @type {(inputs: Tyc_Liability_S62_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6.2 Exclusions`)
};

/**
* | output |
* | --- |
* | "6.2 Exclusions" |
*
* @param {Tyc_Liability_S62_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s62_title = /** @type {((inputs?: Tyc_Liability_S62_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S62_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s62_title(inputs)
	return en_tyc_liability_s62_title(inputs)
});
export { tyc_liability_s62_title as "tyc.liability.s62_title" }